import axios from "axios";
import { AXIOS_TIMEOUT_ERROR_MESSAGE } from "constants/api";
import { ENV_CONFIG_DEFAULT } from "constants/envConfig";

const baseAxios = axios.create({
    baseURL: ENV_CONFIG_DEFAULT.API_URL,
    timeout: ENV_CONFIG_DEFAULT.API_TIME_OUT,
    timeoutErrorMessage: AXIOS_TIMEOUT_ERROR_MESSAGE,
});

export default baseAxios;
